import type { UiLogoProps } from './UiLogo.types';
import { LOGO_COMPONENTS } from './UiLogo.constants';
import { cn } from '@/lib/tailwind';

// The logo markup is inlined (see `components/logos/`) instead of fetched from
// /public after hydration — the header logo is above the fold, so an extra round
// trip after FCP is visible (see AGENTS.md → Performance).
function UiLogo({ variant = 'emblem', className, alt = '' }: UiLogoProps) {
    const Logo = LOGO_COMPONENTS[variant];
    const label = alt.trim();

    return (
        <div className={cn('relative', `is-${variant}`, className)}>
            <Logo {...(label ? { role: 'img', 'aria-label': label } : { 'aria-hidden': true, focusable: false })} />
        </div>
    );
}

export default UiLogo;
